export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  CountryCode: any;
  DateTime: any;
  Decimal: any;
  JSON: any;
  JSONObject: any;
  LanguageCode: any;
  URL: any;
};

export type AProductConnection = {
  __typename?: 'AProductConnection';
  filters: Array<BrFilter>;
  nodes: Array<Product>;
  sorts: Array<Sort>;
  totalCount: Scalars['Int'];
};

export type AProductConnectionMeta = {
  __typename?: 'AProductConnectionMeta';
  defaultSortOrderPoweredBy?: Maybe<MerchSource>;
};

export type AloCollection = {
  __typename?: 'AloCollection';
  handle: Scalars['String'];
};

export type AloProduct = {
  __typename?: 'AloProduct';
  collections: CollectionConnection;
  description: Scalars['String'];
  handle: Scalars['String'];
  id: Scalars['ID'];
  isGiftCard: Scalars['Boolean'];
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  productType: Scalars['String'];
  tags: Array<Scalars['String']>;
  title: Scalars['String'];
  vendor: Scalars['String'];
};


export type AloProductCollectionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

export type AppliedGiftCard = Node & {
  __typename?: 'AppliedGiftCard';
  amountUsed: MoneyV2;
  balance: MoneyV2;
  id: Scalars['ID'];
  lastCharacters: Scalars['String'];
};

export type Attribute = {
  __typename?: 'Attribute';
  key: Scalars['String'];
  value?: Maybe<Scalars['String']>;
};

export type AttributeInput = {
  key: Scalars['String'];
  value: Scalars['String'];
};

export type BaseCartLine = {
  __typename?: 'BaseCartLine';
  attributes: Array<Attribute>;
  cost: CartLineCost;
  discountAllocations: Array<CartDiscountAllocation>;
  id: Scalars['ID'];
  merchandise: Merchandise;
  quantity: Scalars['Int'];
};

export type BaseCartLineConnection = {
  __typename?: 'BaseCartLineConnection';
  edges: Array<BaseCartLineEdge>;
};

export type BaseCartLineEdge = {
  __typename?: 'BaseCartLineEdge';
  node: BaseCartLine;
};

export type BrFilter = ColorFilter | FabricFilter | GroupedListFilter | ListFilter | NumericSliderFilter | SizeFilter;

export enum BrSearchType {
  Category = 'CATEGORY',
  Keyword = 'KEYWORD'
}

export type Cart = {
  __typename?: 'Cart';
  appliedGiftCards: Array<AppliedGiftCard>;
  attributes: Array<Attribute>;
  buyerIdentity: CartBuyerIdentity;
  checkoutUrl: Scalars['URL'];
  cost: CartCost;
  customMetaField?: Maybe<Scalars['JSON']>;
  delivery: CartDelivery;
  deliveryGroups: CartDeliveryGroupConnection;
  discountAllocations: Array<CartDiscountAllocation>;
  discountCodes: Array<CartDiscountCode>;
  id: Scalars['ID'];
  lines: BaseCartLineConnection;
  note?: Maybe<Scalars['String']>;
  totalQuantity: Scalars['Int'];
};


export type CartDeliveryGroupsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  withCarrierRates?: InputMaybe<Scalars['Boolean']>;
};


export type CartLinesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
};

export type CartAddress = CartDeliveryAddress;

export type CartAddressInput = {
  copyFromCustomerAddressId?: InputMaybe<Scalars['ID']>;
  deliveryAddress?: InputMaybe<CartDeliveryAddressInput>;
};

export type CartAttributeUpdate = {
  __typename?: 'CartAttributeUpdate';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartAutomaticDiscountAllocation = CartDiscountAllocation & {
  __typename?: 'CartAutomaticDiscountAllocation';
  discountApplication?: Maybe<DiscountApplication>;
  discountedAmount: MoneyV2;
  targetType?: Maybe<Scalars['String']>;
};

export type CartBuyerIdentity = {
  __typename?: 'CartBuyerIdentity';
  countryCode?: Maybe<Scalars['CountryCode']>;
  customer?: Maybe<Customer>;
  email?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

export type CartBuyerIdentityInput = {
  companyLocationId?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  customerAccessToken?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<CartPreferencesInput>;
};

export type CartBuyerIdentityUpdatePayload = {
  __typename?: 'CartBuyerIdentityUpdatePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartCodeDiscountAllocation = CartDiscountAllocation & {
  __typename?: 'CartCodeDiscountAllocation';
  discountApplication?: Maybe<DiscountApplication>;
  discountedAmount: MoneyV2;
  targetType?: Maybe<Scalars['String']>;
};

export type CartCost = {
  __typename?: 'CartCost';
  subtotalAmount: MoneyV2;
  totalAmount: MoneyV2;
  /**
   * @deprecated Tax and duty amounts are no longer available and will be removed in a future version.
   * Please see [the changelog](https://shopify.dev/changelog/tax-and-duties-are-deprecated-in-storefront-cart-api)
   * for more information.
   *
   */
  totalTaxAmount?: Maybe<MoneyV2>;
};

export type CartCustomDiscountAllocation = CartDiscountAllocation & {
  __typename?: 'CartCustomDiscountAllocation';
  discountApplication?: Maybe<DiscountApplication>;
  discountedAmount: MoneyV2;
  targetType?: Maybe<Scalars['String']>;
};

export type CartDelivery = {
  __typename?: 'CartDelivery';
  addresses: Array<CartSelectableAddress>;
};


export type CartDeliveryAddressesArgs = {
  selected?: InputMaybe<Scalars['Boolean']>;
};

export type CartDeliveryAddress = {
  __typename?: 'CartDeliveryAddress';
  address1?: Maybe<Scalars['String']>;
  address2?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  provinceCode?: Maybe<Scalars['String']>;
  zip?: Maybe<Scalars['String']>;
};

export type CartDeliveryAddressInput = {
  address1?: InputMaybe<Scalars['String']>;
  address2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  company?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  provinceCode?: InputMaybe<Scalars['String']>;
  zip?: InputMaybe<Scalars['String']>;
};

export type CartDeliveryCoordinatesPreferenceInput = {
  countryCode: Scalars['CountryCode'];
  latitude: Scalars['Float'];
  longitude: Scalars['Float'];
};

export type CartDeliveryGroup = {
  __typename?: 'CartDeliveryGroup';
  deliveryOptions: Array<CartDeliveryOption>;
  id: Scalars['ID'];
  selectedDeliveryOption?: Maybe<CartDeliveryOption>;
};

export type CartDeliveryGroupConnection = {
  __typename?: 'CartDeliveryGroupConnection';
  nodes: Array<CartDeliveryGroup>;
};

export enum CartDeliveryGroupType {
  OneTimePurchase = 'ONE_TIME_PURCHASE',
  Subscription = 'SUBSCRIPTION'
}

export type CartDeliveryInput = {
  addresses?: InputMaybe<Array<CartSelectableAddressInput>>;
};

export type CartDeliveryOption = {
  __typename?: 'CartDeliveryOption';
  description?: Maybe<Scalars['String']>;
  estimatedCost: MoneyV2;
  handle: Scalars['String'];
  title?: Maybe<Scalars['String']>;
};

export type CartDeliveryPreferenceInput = {
  coordinates?: InputMaybe<CartDeliveryCoordinatesPreferenceInput>;
  deliveryMethod?: InputMaybe<Array<PreferenceDeliveryMethodType>>;
  pickupHandle?: InputMaybe<Array<Scalars['String']>>;
};

export type CartDiscountAllocation = {
  discountApplication?: Maybe<DiscountApplication>;
  discountedAmount: MoneyV2;
  targetType?: Maybe<Scalars['String']>;
};

export type CartDiscountCode = {
  __typename?: 'CartDiscountCode';
  applicable: Scalars['Boolean'];
  code: Scalars['String'];
};

export type CartDiscountCodesUpdatePayload = {
  __typename?: 'CartDiscountCodesUpdatePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export enum CartErrorCode {
  AddressFieldContainsEmojis = 'ADDRESS_FIELD_CONTAINS_EMOJIS',
  AddressFieldContainsHtmlTags = 'ADDRESS_FIELD_CONTAINS_HTML_TAGS',
  AddressFieldContainsUrl = 'ADDRESS_FIELD_CONTAINS_URL',
  AddressFieldDoesNotMatchExpectedPattern = 'ADDRESS_FIELD_DOES_NOT_MATCH_EXPECTED_PATTERN',
  AddressFieldIsRequired = 'ADDRESS_FIELD_IS_REQUIRED',
  AddressFieldIsTooLong = 'ADDRESS_FIELD_IS_TOO_LONG',
  Invalid = 'INVALID',
  InvalidCompanyLocation = 'INVALID_COMPANY_LOCATION',
  InvalidDeliveryAddressId = 'INVALID_DELIVERY_ADDRESS_ID',
  InvalidDeliveryGroup = 'INVALID_DELIVERY_GROUP',
  InvalidDeliveryOption = 'INVALID_DELIVERY_OPTION',
  InvalidIncrement = 'INVALID_INCREMENT',
  InvalidMerchandiseLine = 'INVALID_MERCHANDISE_LINE',
  InvalidMetafields = 'INVALID_METAFIELDS',
  InvalidPayment = 'INVALID_PAYMENT',
  InvalidPaymentEmptyCart = 'INVALID_PAYMENT_EMPTY_CART',
  InvalidZipCodeForCountry = 'INVALID_ZIP_CODE_FOR_COUNTRY',
  InvalidZipCodeForProvince = 'INVALID_ZIP_CODE_FOR_PROVINCE',
  LessThan = 'LESS_THAN',
  MaximumExceeded = 'MAXIMUM_EXCEEDED',
  MinimumNotMet = 'MINIMUM_NOT_MET',
  MissingCustomerAccessToken = 'MISSING_CUSTOMER_ACCESS_TOKEN',
  MissingDiscountCode = 'MISSING_DISCOUNT_CODE',
  MissingNote = 'MISSING_NOTE',
  NoteTooLong = 'NOTE_TOO_LONG',
  OnlyOneDeliveryAddressCanBeSelected = 'ONLY_ONE_DELIVERY_ADDRESS_CAN_BE_SELECTED',
  PaymentsCreditCardBaseExpired = 'PAYMENTS_CREDIT_CARD_BASE_EXPIRED',
  PaymentsCreditCardBaseGatewayNotSupported = 'PAYMENTS_CREDIT_CARD_BASE_GATEWAY_NOT_SUPPORTED',
  PaymentsCreditCardGeneric = 'PAYMENTS_CREDIT_CARD_GENERIC',
  PaymentsCreditCardMonthInclusion = 'PAYMENTS_CREDIT_CARD_MONTH_INCLUSION',
  PaymentsCreditCardNumberInvalid = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID',
  PaymentsCreditCardNumberInvalidFormat = 'PAYMENTS_CREDIT_CARD_NUMBER_INVALID_FORMAT',
  PaymentsCreditCardVerificationValueBlank = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_BLANK',
  PaymentsCreditCardVerificationValueInvalidForCardType = 'PAYMENTS_CREDIT_CARD_VERIFICATION_VALUE_INVALID_FOR_CARD_TYPE',
  PaymentsCreditCardYearExpired = 'PAYMENTS_CREDIT_CARD_YEAR_EXPIRED',
  PaymentsCreditCardYearInvalidExpiryYear = 'PAYMENTS_CREDIT_CARD_YEAR_INVALID_EXPIRY_YEAR',
  PaymentMethodNotSupported = 'PAYMENT_METHOD_NOT_SUPPORTED',
  ProvinceNotFound = 'PROVINCE_NOT_FOUND',
  TooManyDeliveryAddresses = 'TOO_MANY_DELIVERY_ADDRESSES',
  UnspecifiedAddressError = 'UNSPECIFIED_ADDRESS_ERROR',
  ValidationCustom = 'VALIDATION_CUSTOM',
  ZipCodeNotSupported = 'ZIP_CODE_NOT_SUPPORTED'
}

export type CartGiftCardCodesRemovePayload = {
  __typename?: 'CartGiftCardCodesRemovePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartGiftCardCodesUpdatePayload = {
  __typename?: 'CartGiftCardCodesUpdatePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  buyerIdentity?: InputMaybe<CartBuyerIdentityInput>;
  delivery?: InputMaybe<CartDeliveryInput>;
  discountCodes?: InputMaybe<Array<Scalars['String']>>;
  giftCardCodes?: InputMaybe<Array<Scalars['String']>>;
  lines?: InputMaybe<Array<CartLineInput>>;
  metafields?: InputMaybe<Array<CartInputMetafieldInput>>;
  note?: InputMaybe<Scalars['String']>;
};

export type CartInputMetafieldInput = {
  key: Scalars['String'];
  type: Scalars['String'];
  value: Scalars['String'];
};

export type CartLineCost = {
  __typename?: 'CartLineCost';
  amountPerQuantity: MoneyV2;
  compareAtAmountPerQuantity?: Maybe<MoneyV2>;
  subtotalAmount: MoneyV2;
  totalAmount: MoneyV2;
};

export type CartLineInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  merchandiseId: Scalars['ID'];
  quantity?: InputMaybe<Scalars['Int']>;
  sellingPlanId?: InputMaybe<Scalars['ID']>;
};

export type CartLineUpdateInput = {
  attributes?: InputMaybe<Array<AttributeInput>>;
  id: Scalars['ID'];
  merchandiseId?: InputMaybe<Scalars['ID']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sellingPlanId?: InputMaybe<Scalars['ID']>;
};

export type CartLinesAddPayload = {
  __typename?: 'CartLinesAddPayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartLinesRemovePayload = {
  __typename?: 'CartLinesRemovePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartLinesUpdatePayload = {
  __typename?: 'CartLinesUpdatePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartMergePayload = {
  __typename?: 'CartMergePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartNoteUpdatePayload = {
  __typename?: 'CartNoteUpdatePayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartPayload = {
  __typename?: 'CartPayload';
  cart: Cart;
  customMetaField?: Maybe<Scalars['JSON']>;
  userErrors: Array<CartUserError>;
  warnings: Array<CartWarning>;
};

export type CartPreferencesInput = {
  delivery?: InputMaybe<CartDeliveryPreferenceInput>;
  wallet?: InputMaybe<Array<Scalars['String']>>;
};

export type CartSelectableAddress = {
  __typename?: 'CartSelectableAddress';
  address: CartAddress;
  id: Scalars['ID'];
  oneTimeUse: Scalars['Boolean'];
  selected: Scalars['Boolean'];
};

export type CartSelectableAddressInput = {
  address: CartAddressInput;
};

export type CartUserError = DisplayableError & {
  __typename?: 'CartUserError';
  code?: Maybe<CartErrorCode>;
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type CartWarning = {
  __typename?: 'CartWarning';
  code: CartWarningCode;
  message: Scalars['String'];
  target: Scalars['ID'];
};

export enum CartWarningCode {
  DuplicateDeliveryAddress = 'DUPLICATE_DELIVERY_ADDRESS',
  MerchandiseNotEnoughStock = 'MERCHANDISE_NOT_ENOUGH_STOCK',
  MerchandiseOutOfStock = 'MERCHANDISE_OUT_OF_STOCK',
  PaymentsGiftCardsUnavailable = 'PAYMENTS_GIFT_CARDS_UNAVAILABLE'
}

/**
 * Represents a curated Collection of Products.
 *
 * These could be "Women's Tanks", "Men's Shorts", or "Fall Color Sale".
 *
 * Each Collection is retrieved by it's `handle`, which can be found on aloyoga.com in the URL.
 *
 * Eg: For the "Women's Tanks" collection found here: [https://www.aloyoga.com/collections/womens-tanks](https://www.aloyoga.com/collections/womens-tanks),
 * the `handle` would be `womens-tanks`.
 */
export type Collection = {
  __typename?: 'Collection';
  /** All possible filters based on the products in the `CollectionProducts.Items`. */
  filters: Array<ProductFilter>;
  /** Part of the aloyoga.com URL for the Collection. */
  handle: Scalars['String'];
  /** Globally unique identifier. */
  id: Scalars['ID'];
  /**
   * The products of in this Collection.
   *
   * **Note** that this list of products is curated and may contain duplicate Products where different colors are shown.
   *
   * Eg. In "Women's Tanks", you might see two different colors of the "Aspire
   * Tank" side-by-side on a single page, but they'll be different colors.
   */
  products: CollectionProducts;
  /** Title of the Collection. Eg. "Men's Shorts" */
  title: Scalars['String'];
};


/**
 * Represents a curated Collection of Products.
 *
 * These could be "Women's Tanks", "Men's Shorts", or "Fall Color Sale".
 *
 * Each Collection is retrieved by it's `handle`, which can be found on aloyoga.com in the URL.
 *
 * Eg: For the "Women's Tanks" collection found here: [https://www.aloyoga.com/collections/womens-tanks](https://www.aloyoga.com/collections/womens-tanks),
 * the `handle` would be `womens-tanks`.
 */
export type CollectionProductsArgs = {
  filters?: InputMaybe<Array<ProductFilterInput>>;
  offset?: InputMaybe<Scalars['Int']>;
  size?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<ProductCollectionSortKeys>;
  sortOrder?: InputMaybe<SortOrder>;
};

export type CollectionConnection = {
  __typename?: 'CollectionConnection';
  nodes: Array<AloCollection>;
};

/** Contains pagination info and the items (Products) of this collection. */
export type CollectionProducts = {
  __typename?: 'CollectionProducts';
  items: Array<Product>;
  pageInfo: PageInfo;
};

export type ColorFilter = IFilter & {
  __typename?: 'ColorFilter';
  id: Scalars['String'];
  label: Scalars['String'];
  values: Array<ColorFilterValue>;
};

export type ColorFilterValue = IListFilterValue & {
  __typename?: 'ColorFilterValue';
  count: Scalars['Int'];
  id: Scalars['String'];
  input: Scalars['JSON'];
  label: Scalars['String'];
  /** Hex color code */
  swatch: Scalars['String'];
};

export enum CropRegion {
  /** Keep the bottom of the image. */
  Bottom = 'BOTTOM',
  /** Keep the center of the image. */
  Center = 'CENTER',
  /** Keep the left of the image. */
  Left = 'LEFT',
  /** Keep the right of the image. */
  Right = 'RIGHT',
  /** Keep the top of the image. */
  Top = 'TOP'
}

/** Currency codes. */
export enum CurrencyCode {
  /** United Arab Emirates Dirham (AED). */
  Aed = 'AED',
  /** Afghan Afghani (AFN). */
  Afn = 'AFN',
  /** Albanian Lek (ALL). */
  All = 'ALL',
  /** Armenian Dram (AMD). */
  Amd = 'AMD',
  /** Netherlands Antillean Guilder. */
  Ang = 'ANG',
  /** Angolan Kwanza (AOA). */
  Aoa = 'AOA',
  /** Argentine Pesos (ARS). */
  Ars = 'ARS',
  /** Australian Dollars (AUD). */
  Aud = 'AUD',
  /** Aruban Florin (AWG). */
  Awg = 'AWG',
  /** Azerbaijani Manat (AZN). */
  Azn = 'AZN',
  /** Bosnia and Herzegovina Convertible Mark (BAM). */
  Bam = 'BAM',
  /** Barbadian Dollar (BBD). */
  Bbd = 'BBD',
  /** Bangladesh Taka (BDT). */
  Bdt = 'BDT',
  /** Bulgarian Lev (BGN). */
  Bgn = 'BGN',
  /** Bahraini Dinar (BHD). */
  Bhd = 'BHD',
  /** Burundian Franc (BIF). */
  Bif = 'BIF',
  /** Bermudian Dollar (BMD). */
  Bmd = 'BMD',
  /** Brunei Dollar (BND). */
  Bnd = 'BND',
  /** Bolivian Boliviano (BOB). */
  Bob = 'BOB',
  /** Brazilian Real (BRL). */
  Brl = 'BRL',
  /** Bahamian Dollar (BSD). */
  Bsd = 'BSD',
  /** Bhutanese Ngultrum (BTN). */
  Btn = 'BTN',
  /** Botswana Pula (BWP). */
  Bwp = 'BWP',
  /** Belarusian Ruble (BYN). */
  Byn = 'BYN',
  /**
   * Belarusian Ruble (BYR).
   * @deprecated `BYR` is deprecated. Use `BYN` available from version `2021-01` onwards instead.
   */
  Byr = 'BYR',
  /** Belize Dollar (BZD). */
  Bzd = 'BZD',
  /** Canadian Dollars (CAD). */
  Cad = 'CAD',
  /** Congolese franc (CDF). */
  Cdf = 'CDF',
  /** Swiss Francs (CHF). */
  Chf = 'CHF',
  /** Chilean Peso (CLP). */
  Clp = 'CLP',
  /** Chinese Yuan Renminbi (CNY). */
  Cny = 'CNY',
  /** Colombian Peso (COP). */
  Cop = 'COP',
  /** Costa Rican Colones (CRC). */
  Crc = 'CRC',
  /** Cape Verdean escudo (CVE). */
  Cve = 'CVE',
  /** Czech Koruny (CZK). */
  Czk = 'CZK',
  /** Djiboutian Franc (DJF). */
  Djf = 'DJF',
  /** Danish Kroner (DKK). */
  Dkk = 'DKK',
  /** Dominican Peso (DOP). */
  Dop = 'DOP',
  /** Algerian Dinar (DZD). */
  Dzd = 'DZD',
  /** Egyptian Pound (EGP). */
  Egp = 'EGP',
  /** Eritrean Nakfa (ERN). */
  Ern = 'ERN',
  /** Ethiopian Birr (ETB). */
  Etb = 'ETB',
  /** Euro (EUR). */
  Eur = 'EUR',
  /** Fijian Dollars (FJD). */
  Fjd = 'FJD',
  /** Falkland Islands Pounds (FKP). */
  Fkp = 'FKP',
  /** United Kingdom Pounds (GBP). */
  Gbp = 'GBP',
  /** Georgian Lari (GEL). */
  Gel = 'GEL',
  /** Ghanaian Cedi (GHS). */
  Ghs = 'GHS',
  /** Gibraltar Pounds (GIP). */
  Gip = 'GIP',
  /** Gambian Dalasi (GMD). */
  Gmd = 'GMD',
  /** Guinean Franc (GNF). */
  Gnf = 'GNF',
  /** Guatemalan Quetzal (GTQ). */
  Gtq = 'GTQ',
  /** Guyanese Dollar (GYD). */
  Gyd = 'GYD',
  /** Hong Kong Dollars (HKD). */
  Hkd = 'HKD',
  /** Honduran Lempira (HNL). */
  Hnl = 'HNL',
  /** Croatian Kuna (HRK). */
  Hrk = 'HRK',
  /** Haitian Gourde (HTG). */
  Htg = 'HTG',
  /** Hungarian Forint (HUF). */
  Huf = 'HUF',
  /** Indonesian Rupiah (IDR). */
  Idr = 'IDR',
  /** Israeli New Shekel (NIS). */
  Ils = 'ILS',
  /** Indian Rupees (INR). */
  Inr = 'INR',
  /** Iraqi Dinar (IQD). */
  Iqd = 'IQD',
  /** Iranian Rial (IRR). */
  Irr = 'IRR',
  /** Icelandic Kronur (ISK). */
  Isk = 'ISK',
  /** Jersey Pound. */
  Jep = 'JEP',
  /** Jamaican Dollars (JMD). */
  Jmd = 'JMD',
  /** Jordanian Dinar (JOD). */
  Jod = 'JOD',
  /** Japanese Yen (JPY). */
  Jpy = 'JPY',
  /** Kenyan Shilling (KES). */
  Kes = 'KES',
  /** Kyrgyzstani Som (KGS). */
  Kgs = 'KGS',
  /** Cambodian Riel. */
  Khr = 'KHR',
  /** Kiribati Dollar (KID). */
  Kid = 'KID',
  /** Comorian Franc (KMF). */
  Kmf = 'KMF',
  /** South Korean Won (KRW). */
  Krw = 'KRW',
  /** Kuwaiti Dinar (KWD). */
  Kwd = 'KWD',
  /** Cayman Dollars (KYD). */
  Kyd = 'KYD',
  /** Kazakhstani Tenge (KZT). */
  Kzt = 'KZT',
  /** Laotian Kip (LAK). */
  Lak = 'LAK',
  /** Lebanese Pounds (LBP). */
  Lbp = 'LBP',
  /** Sri Lankan Rupees (LKR). */
  Lkr = 'LKR',
  /** Liberian Dollar (LRD). */
  Lrd = 'LRD',
  /** Lesotho Loti (LSL). */
  Lsl = 'LSL',
  /** Lithuanian Litai (LTL). */
  Ltl = 'LTL',
  /** Latvian Lati (LVL). */
  Lvl = 'LVL',
  /** Libyan Dinar (LYD). */
  Lyd = 'LYD',
  /** Moroccan Dirham. */
  Mad = 'MAD',
  /** Moldovan Leu (MDL). */
  Mdl = 'MDL',
  /** Malagasy Ariary (MGA). */
  Mga = 'MGA',
  /** Macedonia Denar (MKD). */
  Mkd = 'MKD',
  /** Burmese Kyat (MMK). */
  Mmk = 'MMK',
  /** Mongolian Tugrik. */
  Mnt = 'MNT',
  /** Macanese Pataca (MOP). */
  Mop = 'MOP',
  /** Mauritanian Ouguiya (MRU). */
  Mru = 'MRU',
  /** Mauritian Rupee (MUR). */
  Mur = 'MUR',
  /** Maldivian Rufiyaa (MVR). */
  Mvr = 'MVR',
  /** Malawian Kwacha (MWK). */
  Mwk = 'MWK',
  /** Mexican Pesos (MXN). */
  Mxn = 'MXN',
  /** Malaysian Ringgits (MYR). */
  Myr = 'MYR',
  /** Mozambican Metical. */
  Mzn = 'MZN',
  /** Namibian Dollar. */
  Nad = 'NAD',
  /** Nigerian Naira (NGN). */
  Ngn = 'NGN',
  /** Nicaraguan Córdoba (NIO). */
  Nio = 'NIO',
  /** Norwegian Kroner (NOK). */
  Nok = 'NOK',
  /** Nepalese Rupee (NPR). */
  Npr = 'NPR',
  /** New Zealand Dollars (NZD). */
  Nzd = 'NZD',
  /** Omani Rial (OMR). */
  Omr = 'OMR',
  /** Panamian Balboa (PAB). */
  Pab = 'PAB',
  /** Peruvian Nuevo Sol (PEN). */
  Pen = 'PEN',
  /** Papua New Guinean Kina (PGK). */
  Pgk = 'PGK',
  /** Philippine Peso (PHP). */
  Php = 'PHP',
  /** Pakistani Rupee (PKR). */
  Pkr = 'PKR',
  /** Polish Zlotych (PLN). */
  Pln = 'PLN',
  /** Paraguayan Guarani (PYG). */
  Pyg = 'PYG',
  /** Qatari Rial (QAR). */
  Qar = 'QAR',
  /** Romanian Lei (RON). */
  Ron = 'RON',
  /** Serbian dinar (RSD). */
  Rsd = 'RSD',
  /** Russian Rubles (RUB). */
  Rub = 'RUB',
  /** Rwandan Franc (RWF). */
  Rwf = 'RWF',
  /** Saudi Riyal (SAR). */
  Sar = 'SAR',
  /** Solomon Islands Dollar (SBD). */
  Sbd = 'SBD',
  /** Seychellois Rupee (SCR). */
  Scr = 'SCR',
  /** Sudanese Pound (SDG). */
  Sdg = 'SDG',
  /** Swedish Kronor (SEK). */
  Sek = 'SEK',
  /** Singapore Dollars (SGD). */
  Sgd = 'SGD',
  /** Saint Helena Pounds (SHP). */
  Shp = 'SHP',
  /** Sierra Leonean Leone (SLL). */
  Sll = 'SLL',
  /** Somali Shilling (SOS). */
  Sos = 'SOS',
  /** Surinamese Dollar (SRD). */
  Srd = 'SRD',
  /** South Sudanese Pound (SSP). */
  Ssp = 'SSP',
  /**
   * Sao Tome And Principe Dobra (STD).
   * @deprecated `STD` is deprecated. Use `STN` available from version `2022-07` onwards instead.
   */
  Std = 'STD',
  /** Sao Tome And Principe Dobra (STN). */
  Stn = 'STN',
  /** Syrian Pound (SYP). */
  Syp = 'SYP',
  /** Swazi Lilangeni (SZL). */
  Szl = 'SZL',
  /** Thai baht (THB). */
  Thb = 'THB',
  /** Tajikistani Somoni (TJS). */
  Tjs = 'TJS',
  /** Turkmenistani Manat (TMT). */
  Tmt = 'TMT',
  /** Tunisian Dinar (TND). */
  Tnd = 'TND',
  /** Tongan Pa'anga (TOP). */
  Top = 'TOP',
  /** Turkish Lira (TRY). */
  Try = 'TRY',
  /** Trinidad and Tobago Dollars (TTD). */
  Ttd = 'TTD',
  /** Taiwan Dollars (TWD). */
  Twd = 'TWD',
  /** Tanzanian Shilling (TZS). */
  Tzs = 'TZS',
  /** Ukrainian Hryvnia (UAH). */
  Uah = 'UAH',
  /** Ugandan Shilling (UGX). */
  Ugx = 'UGX',
  /** United States Dollars (USD). */
  Usd = 'USD',
  /** Uruguayan Pesos (UYU). */
  Uyu = 'UYU',
  /** Uzbekistan som (UZS). */
  Uzs = 'UZS',
  /** Venezuelan Bolivares (VED). */
  Ved = 'VED',
  /**
   * Venezuelan Bolivares (VEF).
   * @deprecated `VEF` is deprecated. Use `VES` available from version `2020-10` onwards instead.
   */
  Vef = 'VEF',
  /** Venezuelan Bolivares Soberanos (VES). */
  Ves = 'VES',
  /** Vietnamese đồng (VND). */
  Vnd = 'VND',
  /** Vanuatu Vatu (VUV). */
  Vuv = 'VUV',
  /** Samoan Tala (WST). */
  Wst = 'WST',
  /** Central African CFA Franc (XAF). */
  Xaf = 'XAF',
  /** East Caribbean Dollar (XCD). */
  Xcd = 'XCD',
  /** West African CFA franc (XOF). */
  Xof = 'XOF',
  /** CFP Franc (XPF). */
  Xpf = 'XPF',
  /** Unrecognized currency. */
  Xxx = 'XXX',
  /** Yemeni Rial (YER). */
  Yer = 'YER',
  /** South African Rand (ZAR). */
  Zar = 'ZAR',
  /** Zambian Kwacha (ZMW). */
  Zmw = 'ZMW'
}

export type Customer = {
  __typename?: 'Customer';
  email?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
};

export enum DeliveryMethodType {
  Local = 'LOCAL',
  None = 'NONE',
  PickupPoint = 'PICKUP_POINT',
  PickUp = 'PICK_UP',
  Retail = 'RETAIL',
  Shipping = 'SHIPPING'
}

export type DiscountApplication = {
  __typename?: 'DiscountApplication';
  value: DiscountApplicationValue;
};

export enum DiscountApplicationTargetType {
  LineItem = 'LINE_ITEM',
  ShippingLine = 'SHIPPING_LINE'
}

export type DiscountApplicationValue = MoneyV2 | PricingPercentageValue;

export type DisplayableError = {
  field?: Maybe<Array<Scalars['String']>>;
  message: Scalars['String'];
};

export type FabricFilter = IFilter & {
  __typename?: 'FabricFilter';
  id: Scalars['String'];
  label: Scalars['String'];
  values: Array<FabricFilterValue>;
};

export type FabricFilterValue = IListFilterValue & {
  __typename?: 'FabricFilterValue';
  count: Scalars['Int'];
  description: Scalars['String'];
  id: Scalars['String'];
  input: Scalars['JSON'];
  label: Scalars['String'];
};

export type FilterValue = {
  __typename?: 'FilterValue';
  key: Scalars['String'];
  title: Scalars['String'];
};

export type FiltersInput = {
  key: Scalars['String'];
  values: Array<InputMaybe<Scalars['String']>>;
};

export enum Gender {
  Men = 'Men',
  Women = 'Women'
}

export enum GenderType {
  Men = 'Men',
  Women = 'Women'
}

export type GroupListFilterGroup = {
  __typename?: 'GroupListFilterGroup';
  label: Scalars['String'];
  values: Array<ListFilterValue>;
};

export type GroupedListFilter = IFilter & {
  __typename?: 'GroupedListFilter';
  groups: Array<GroupListFilterGroup>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type IFilter = {
  id: Scalars['String'];
  label: Scalars['String'];
};

export type IListFilterValue = {
  count: Scalars['Int'];
  id: Scalars['String'];
  input: Scalars['JSON'];
  label: Scalars['String'];
};

/** A Product in a Set */
export type IProduct = {
  __typename?: 'IProduct';
  availableColorsMetafieldValue?: Maybe<Scalars['String']>;
  options: Array<ProductOption>;
  /** The type of product. Eg: `Women:Bras` */
  productType: Scalars['String'];
  /** Title of the product */
  title: Scalars['String'];
  /** The Variants of this Product; Variants are where the SKUs are. */
  variants: Array<IVariant>;
};

/** Represents a "sellable" product; in Shopify only variants have SKUs and inventory. */
export type IVariant = {
  __typename?: 'IVariant';
  /** Base64 decoded version of id */
  adminId: Scalars['String'];
  /** Is this variant currently available for sale. */
  availableForSale: Scalars['Boolean'];
  /**
   * This represents a price to compare the current `price` against. Eg. If this
   * variant is currently on sale, the `price` would
   * be the price that counts towards the total, and the `compareAtPrice` would be the "original" price.
   * The `compareAtPrice` might be shown striked-through ("Was ~~$99.99~~") to indicate a sale price, or other change in price.
   */
  compareAtPrice?: Maybe<Scalars['Float']>;
  id: Scalars['String'];
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /**
   * This represents actual price the variant is being sold at.
   * @See `compareAtPrice`
   * TODO: Price in USD???
   */
  price: Scalars['Float'];
  /** Product handle */
  productHandle: Scalars['String'];
  /** Product ID */
  productId?: Maybe<Scalars['String']>;
  /** Product tags */
  productTags: Array<Scalars['String']>;
  /** How many of this variant are still available. */
  quantityAvailable: Scalars['Int'];
  /** Does this variant require shipping. */
  requiresShipping: Scalars['Boolean'];
  /** Selectable options for this variant. */
  selectionOptions: Array<SelectedOption>;
  /** SKU */
  sku: Scalars['String'];
};

export type Image = {
  __typename?: 'Image';
  altText?: Maybe<Scalars['String']>;
  url: Scalars['URL'];
};


export type ImageUrlArgs = {
  transform?: InputMaybe<ImageTransformInput>;
};

export enum ImageContentType {
  Jpg = 'JPG',
  Png = 'PNG',
  Webp = 'WEBP'
}

export type ImageTransformInput = {
  crop?: InputMaybe<CropRegion>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  preferredContentType?: InputMaybe<ImageContentType>;
  scale?: InputMaybe<Scalars['Int']>;
};

export type ImagesByColor = {
  __typename?: 'ImagesByColor';
  key: Scalars['String'];
  values: Array<Scalars['String']>;
};

export type Legacy_GenderFacet = {
  __typename?: 'Legacy_GenderFacet';
  title: Scalars['String'];
  values: Array<Legacy_GenderFacetValue>;
};

export type Legacy_GenderFacetValue = {
  __typename?: 'Legacy_GenderFacetValue';
  count: Scalars['Int'];
  key: Gender;
  title: Scalars['String'];
};

export type ListFilter = IFilter & {
  __typename?: 'ListFilter';
  id: Scalars['String'];
  label: Scalars['String'];
  values: Array<ListFilterValue>;
};

export type ListFilterValue = IListFilterValue & {
  __typename?: 'ListFilterValue';
  count: Scalars['Int'];
  id: Scalars['String'];
  input: Scalars['JSON'];
  label: Scalars['String'];
};

/** Any images or videos for a Set. */
export type Media = {
  __typename?: 'Media';
  images: Array<Scalars['String']>;
  imagesByColor: Array<ImagesByColor>;
  videoUrl?: Maybe<Scalars['String']>;
};

export enum MerchSource {
  Bloomreach = 'BLOOMREACH',
  Shopify = 'SHOPIFY'
}

export type Merchandise = ProductVariant;

export type Metafield = {
  __typename?: 'Metafield';
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['ID'];
  key: Scalars['String'];
  namespace: Scalars['String'];
  type: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  value: Scalars['String'];
};

export type MetafieldValue = {
  __typename?: 'MetafieldValue';
  value: Scalars['String'];
};

export type MoneyV2 = {
  __typename?: 'MoneyV2';
  amount: Scalars['Decimal'];
  currencyCode: CurrencyCode;
};

export type Mutation = {
  __typename?: 'Mutation';
  cartAttributesUpdate?: Maybe<CartAttributeUpdate>;
  cartBuyerIdentityUpdate?: Maybe<CartBuyerIdentityUpdatePayload>;
  cartDiscountCodesUpdate?: Maybe<CartDiscountCodesUpdatePayload>;
  cartGiftCardCodesRemove?: Maybe<CartGiftCardCodesRemovePayload>;
  cartGiftCardCodesUpdate?: Maybe<CartGiftCardCodesUpdatePayload>;
  cartLinesAdd?: Maybe<CartLinesAddPayload>;
  cartLinesRemove?: Maybe<CartLinesRemovePayload>;
  cartLinesUpdate?: Maybe<CartLinesUpdatePayload>;
  cartNoteUpdate?: Maybe<CartNoteUpdatePayload>;
  mergeCartOnLogin?: Maybe<CartMergePayload>;
  migrateActiveCart?: Maybe<CartPayload>;
};


export type MutationCartAttributesUpdateArgs = {
  attributes: Array<AttributeInput>;
};


export type MutationCartBuyerIdentityUpdateArgs = {
  buyerIdentity: CartBuyerIdentityInput;
};


export type MutationCartDiscountCodesUpdateArgs = {
  discountCodes?: InputMaybe<Array<Scalars['String']>>;
};


export type MutationCartGiftCardCodesRemoveArgs = {
  appliedGiftCardIds: Array<Scalars['ID']>;
};


export type MutationCartGiftCardCodesUpdateArgs = {
  giftCardCodes: Array<Scalars['String']>;
};


export type MutationCartLinesAddArgs = {
  lines: Array<CartLineInput>;
};


export type MutationCartLinesRemoveArgs = {
  lineIds: Array<Scalars['ID']>;
};


export type MutationCartLinesUpdateArgs = {
  lines: Array<CartLineUpdateInput>;
};


export type MutationCartNoteUpdateArgs = {
  note: Scalars['String'];
};


export type MutationMergeCartOnLoginArgs = {
  buyerIdentity: CartBuyerIdentityInput;
};


export type MutationMigrateActiveCartArgs = {
  cartId?: InputMaybe<Scalars['ID']>;
};

export type Node = {
  id: Scalars['ID'];
};

export type NumericSliderFilter = IFilter & {
  __typename?: 'NumericSliderFilter';
  id: Scalars['String'];
  label: Scalars['String'];
  max: Scalars['Int'];
  min: Scalars['Int'];
  step: Scalars['Int'];
};

/** Pagination mechanism forthcoming, currently returns the total count only. */
export type PageInfo = {
  __typename?: 'PageInfo';
  /** Total count of items in this collection. */
  totalCount: Scalars['Int'];
};

export enum PreferenceDeliveryMethodType {
  PickupPoint = 'PICKUP_POINT',
  PickUp = 'PICK_UP',
  Shipping = 'SHIPPING'
}

export type PricingPercentageValue = {
  __typename?: 'PricingPercentageValue';
  percentage: Scalars['Float'];
};

export type Product = {
  __typename?: 'Product';
  availableColorsMetafieldValue?: Maybe<Scalars['String']>;
  availableForSale: Scalars['Boolean'];
  /** The compare at price of the product across all variants. */
  compareAtPriceRange: ProductPriceRange;
  gid: Scalars['ID'];
  /**
   * A human-friendly unique string for the Product automatically generated from its title.
   * They are used by the Liquid templating language to refer to objects.
   */
  handle: Scalars['String'];
  /**
   * Globally unique identifier.
   * @deprecated Use gid instead.
   */
  id: Scalars['ID'];
  /** List of images associated with the product. */
  images: Array<Scalars['String']>;
  /**
   * The online store URL for the product.
   * A value of  indicates that the product is not published to the Online Store sales channel.
   */
  onlineStoreUrl?: Maybe<Scalars['URL']>;
  /** List of product options. */
  options: Array<ProductOption>;
  /** The price range. */
  priceRange: ProductPriceRange;
  /** A categorization that a product can be tagged with, commonly used for filtering and searching. */
  productType: Scalars['String'];
  /**
   * A comma separated list of tags that have been added to the product.
   * Additional access scope required for private apps: unauthenticated_read_product_tags.
   */
  tags: Array<Scalars['String']>;
  /** The product’s title. */
  title: Scalars['String'];
  /** The total quantity of inventory in stock for this Product. */
  totalInventory?: Maybe<Scalars['Int']>;
  /** List of the product’s variants. */
  variants: Array<Variant>;
  vendor: Scalars['String'];
};


export type ProductImagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  crop?: InputMaybe<CropRegion>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  maxHeight?: InputMaybe<Scalars['Int']>;
  maxWidth?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  scale?: InputMaybe<Scalars['Int']>;
  sortKey?: InputMaybe<ProductImageSortKeys>;
};


export type ProductOptionsArgs = {
  first?: InputMaybe<Scalars['Int']>;
};

/** This is a comment that will make it into the docs? */
export type ProductAttribute = {
  __typename?: 'ProductAttribute';
  content: Scalars['String'];
  key: Scalars['String'];
  title: Scalars['String'];
  type: Scalars['String'];
};

export type ProductCategory = {
  __typename?: 'ProductCategory';
  id: Scalars['ID'];
  products?: Maybe<ProductList>;
  title: Scalars['String'];
};


export type ProductCategoryProductsArgs = {
  filters?: InputMaybe<Array<FiltersInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  reverse?: InputMaybe<Scalars['Boolean']>;
  sortKey?: InputMaybe<SearchSortKeys>;
};

export enum ProductCollectionSortKeys {
  AlgoModel_1 = 'ALGO_MODEL_1',
  BestSelling = 'BEST_SELLING',
  CollectionDefault = 'COLLECTION_DEFAULT',
  Created = 'CREATED',
  Id = 'ID',
  Manual = 'MANUAL',
  Price = 'PRICE',
  Relevance = 'RELEVANCE',
  Title = 'TITLE'
}

/**
 * A Facet (Option/Filter) for a Product.
 * TODO: Should we change this to ProductFacets?
 */
export type ProductFilter = {
  __typename?: 'ProductFilter';
  /** Key for this filter, usually something like `color`, or `size`. */
  key: Scalars['String'];
  /** The title of this filter, usually just the capitalized version of the key, eg. `Color`, and `Size`. */
  title: Scalars['String'];
  /** All options for this filter based on the `products` found in this `collection`. */
  values: Array<FilterValue>;
};

/**
 * A set of key and values to filter for by inclusion. Eg. The user may want to only see "Black", and "Orange" colored items:
 * ```
 * query {
 *   womensTanks: collectionByHandle(handle: "womens-tanks") {
 *     # ...Collection Fields
 *     products(filters:{
 *           key:"Color",
 *           values:["Black", "Orange"]
 *     }) {
 *       items {
 *         # ...Product Fields
 *       }
 *     }
 *   }
 * }
 * ```
 */
export type ProductFilterInput = {
  /** Filter Key. Eg. `color`. */
  key: Scalars['String'];
  /** Filter Values. Eg. `["Red", "Green"]`. */
  values: Array<Scalars['String']>;
};

export enum ProductImageSortKeys {
  CreatedAt = 'CREATED_AT',
  Id = 'ID',
  Position = 'POSITION',
  Relevance = 'RELEVANCE'
}

export type ProductList = {
  __typename?: 'ProductList';
  filters: Array<BrFilter>;
  meta: AProductConnectionMeta;
  nodes: Array<Product>;
  sorts: Array<Sort>;
  totalCount: Scalars['Int'];
};

export type ProductOption = {
  __typename?: 'ProductOption';
  name: Scalars['String'];
  /** The corresponding value to the product option name. */
  values: Array<Scalars['String']>;
};

export type ProductPriceRange = {
  __typename?: 'ProductPriceRange';
  maxVariantPrice: MoneyV2;
  minVariantPrice: MoneyV2;
};

/** A Set is a "dummy" product that encapsulates a small curated list of products that must be purchased together. */
export type ProductSet = {
  __typename?: 'ProductSet';
  /** Textual attributes of a Set, currently contains the "FABRICATION", and "FIT" sections at the bottom of a Set PDP. */
  attributes: Array<ProductAttribute>;
  /** Price without discounts. */
  compareAtPrice?: Maybe<Scalars['Float']>;
  /** Description of this Set */
  description?: Maybe<Scalars['String']>;
  /** Description (HTML) of this Set */
  descriptionHtml: Scalars['String'];
  /** Part of the URL for this set that uniquely identifies it */
  handle: Scalars['String'];
  /** Any images or videos for this Set. */
  media: Media;
  /** Price of the Set. */
  price?: Maybe<Scalars['Float']>;
  /** The curated Products of this Set. */
  products: Array<IProduct>;
  /** Set Tags */
  tags: Array<Scalars['String']>;
  /** Title of the Set */
  title: Scalars['String'];
};

export type ProductVariant = {
  __typename?: 'ProductVariant';
  availableForSale: Scalars['Boolean'];
  compareAtPrice?: Maybe<MoneyV2>;
  estimatedShipDate?: Maybe<MetafieldValue>;
  id: Scalars['ID'];
  image?: Maybe<Image>;
  metafield?: Maybe<Metafield>;
  price: MoneyV2;
  product: AloProduct;
  quantityAvailable?: Maybe<Scalars['Int']>;
  requiresShipping: Scalars['Boolean'];
  selectedOptions: Array<SelectedOption>;
  sku?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};


export type ProductVariantMetafieldArgs = {
  key: Scalars['String'];
  namespace?: InputMaybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getCart?: Maybe<CartPayload>;
  productByHandle?: Maybe<Product>;
  productsByCollectionHandle?: Maybe<ProductCategory>;
  productsByHandle: Array<Product>;
  productsByHandles: Array<Product>;
  productsByProductIds: Array<Product>;
  recommendedProductsByProductId?: Maybe<Array<Maybe<Product>>>;
  searchProducts?: Maybe<SearchResp>;
  /** @deprecated Use `searchProducts` instead */
  searchResults: SearchResults;
  /** @deprecated Merch will no longer publish sets */
  setByHandle?: Maybe<ProductSet>;
  suggest: SuggestResults;
  whateverwewant?: Maybe<Scalars['JSON']>;
};


export type QueryProductByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryProductsByCollectionHandleArgs = {
  gender?: InputMaybe<GenderType>;
  handle: Scalars['String'];
  tagHandle?: InputMaybe<Scalars['String']>;
};


export type QueryProductsByHandleArgs = {
  handle: Scalars['String'];
};


export type QueryProductsByHandlesArgs = {
  handles: Array<Scalars['String']>;
};


export type QueryProductsByProductIdsArgs = {
  productIds: Array<Scalars['String']>;
};


export type QueryRecommendedProductsByProductIdArgs = {
  doNotRecommend?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  first?: InputMaybe<Scalars['Int']>;
  productId: Scalars['String'];
  recommendationScheme?: InputMaybe<Scalars['String']>;
  sizeNameInStock?: InputMaybe<Scalars['String']>;
};


export type QuerySearchProductsArgs = {
  filters?: InputMaybe<Array<FiltersInput>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  reverse?: InputMaybe<Scalars['Boolean']>;
  searchType?: InputMaybe<BrSearchType>;
  sortKey?: InputMaybe<SearchSortKeys>;
};


export type QuerySearchResultsArgs = {
  gender?: InputMaybe<Gender>;
  pageIndex?: InputMaybe<Scalars['Int']>;
  pageSize?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  sortBy?: InputMaybe<SortBy>;
  sortOrder?: InputMaybe<SortOrder>;
};


export type QuerySetByHandleArgs = {
  handle: Scalars['String'];
};


export type QuerySuggestArgs = {
  productSize?: InputMaybe<Scalars['Int']>;
  query: Scalars['String'];
  querySuggestionSize?: InputMaybe<Scalars['Int']>;
  searchService?: InputMaybe<SearchService>;
};

export type Redirect = {
  __typename?: 'Redirect';
  info?: Maybe<Scalars['JSON']>;
  /**
   * Path will always have a leading slash
   * @deprecated Use `url` instead.
   */
  path: Scalars['String'];
  url: Scalars['String'];
};

export type SearchResp = AProductConnection | Redirect;

export type SearchResults = {
  __typename?: 'SearchResults';
  _rawSearchResponse?: Maybe<Scalars['JSONObject']>;
  _rawSearchResponseFull?: Maybe<Scalars['JSONObject']>;
  genderFacet?: Maybe<Legacy_GenderFacet>;
  products: Array<Product>;
  redirect?: Maybe<Scalars['String']>;
  totalCount?: Maybe<Scalars['Int']>;
};

export enum SearchService {
  Bloomreach = 'bloomreach'
}

export enum SearchSortKeys {
  BestSelling = 'BEST_SELLING',
  Default = 'DEFAULT',
  Newest = 'NEWEST',
  PriceHighToLow = 'PRICE_HIGH_TO_LOW',
  PriceLowToHigh = 'PRICE_LOW_TO_HIGH'
}

export type SelectedOption = {
  __typename?: 'SelectedOption';
  name: Scalars['String'];
  value: Scalars['String'];
};

export type SizeFilter = IFilter & {
  __typename?: 'SizeFilter';
  groups: Array<GroupListFilterGroup>;
  id: Scalars['String'];
  label: Scalars['String'];
};

export type Sort = {
  __typename?: 'Sort';
  label: Scalars['String'];
  value: SearchSortKeys;
};

export enum SortBy {
  Created = 'created',
  Price = 'price',
  Relevance = 'relevance',
  SalesAmount = 'sales_amount'
}

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SuggestResults = {
  __typename?: 'SuggestResults';
  products: Array<Product>;
  querySuggestions: Array<Scalars['String']>;
};

export type Variant = {
  __typename?: 'Variant';
  /** Is this variant currently available for sale. */
  availableForSale: Scalars['Boolean'];
  /** This represents a price to compare the current price against. */
  compareAtPrice?: Maybe<MoneyV2>;
  gid: Scalars['String'];
  /** Image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** This represents actual price the variant is being sold at. */
  price: MoneyV2;
  /** Selectable options for this variant. */
  selectedOptions: Array<SelectedOption>;
  /** SKU */
  sku: Scalars['String'];
  /** Title of the variant. */
  title: Scalars['String'];
};

export type SearchSuggestionsQueryVariables = Exact<{
  query: Scalars['String'];
  querySuggestionSize: Scalars['Int'];
  productSize: Scalars['Int'];
  searchService: SearchService;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type SearchSuggestionsQuery = { __typename?: 'Query', suggest: { __typename?: 'SuggestResults', querySuggestions: Array<string>, products: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }> } };

export type RecommendedProductsByProductIdQueryVariables = Exact<{
  productId: Scalars['String'];
  first?: InputMaybe<Scalars['Int']>;
  sizeNameInStock?: InputMaybe<Scalars['String']>;
  recommendationScheme?: InputMaybe<Scalars['String']>;
  doNotRecommend?: InputMaybe<Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type RecommendedProductsByProductIdQuery = { __typename?: 'Query', recommendedProductsByProductId?: Array<{ __typename?: 'Product', availableForSale: boolean, availableColorsMetafieldValue?: string | null, handle: string, id: string, images: Array<string>, onlineStoreUrl?: any | null, productType: string, tags: Array<string>, title: string, totalInventory?: number | null, vendor: string, gid: string, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, minVariantPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }>, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, minVariantPrice: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } } | null> | null };

export type GetBrCollectionQueryVariables = Exact<{
  handle: Scalars['String'];
  limit?: InputMaybe<Scalars['Int']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type GetBrCollectionQuery = { __typename?: 'Query', productsByCollectionHandle?: { __typename?: 'ProductCategory', products?: { __typename?: 'ProductList', nodes: Array<{ __typename?: 'Product', gid: string, handle: string, title: string, images: Array<string>, tags: Array<string>, variants: Array<{ __typename?: 'Variant', gid: string, availableForSale: boolean, title: string, imageUrl?: string | null, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null }>, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }> } | null } | null };

export type CollectionDataFragment = { __typename?: 'ProductCategory', products?: { __typename?: 'ProductList', nodes: Array<{ __typename?: 'Product', gid: string, handle: string, title: string, images: Array<string>, tags: Array<string>, variants: Array<{ __typename?: 'Variant', gid: string, availableForSale: boolean, title: string, imageUrl?: string | null, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null }>, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }> } | null };

export type ProductCollectionFragment = { __typename?: 'ProductList', nodes: Array<{ __typename?: 'Product', gid: string, handle: string, title: string, images: Array<string>, tags: Array<string>, variants: Array<{ __typename?: 'Variant', gid: string, availableForSale: boolean, title: string, imageUrl?: string | null, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null }>, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }> };

export type ProductsFragment = { __typename?: 'Product', gid: string, handle: string, title: string, images: Array<string>, tags: Array<string>, variants: Array<{ __typename?: 'Variant', gid: string, availableForSale: boolean, title: string, imageUrl?: string | null, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null }>, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> };

export type GetCollectionDataQueryVariables = Exact<{
  handle: Scalars['String'];
  tagHandle?: InputMaybe<Scalars['String']>;
  gender?: InputMaybe<GenderType>;
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<FiltersInput> | FiltersInput>;
  sortKey?: InputMaybe<SearchSortKeys>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type GetCollectionDataQuery = { __typename?: 'Query', productsByCollectionHandle?: { __typename?: 'ProductCategory', id: string, title: string, products?: { __typename?: 'ProductList', totalCount: number, nodes: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }>, meta: { __typename?: 'AProductConnectionMeta', defaultSortOrderPoweredBy?: MerchSource | null }, filters: Array<{ __typename?: 'ColorFilter', id: string, label: string, values: Array<{ __typename?: 'ColorFilterValue', count: number, id: string, input: any, label: string, swatch: string }> } | { __typename?: 'FabricFilter', id: string, label: string, values: Array<{ __typename?: 'FabricFilterValue', count: number, id: string, input: any, label: string, description: string }> } | { __typename?: 'GroupedListFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> } | { __typename?: 'ListFilter', id: string, label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> } | { __typename?: 'NumericSliderFilter', id: string, label: string, max: number, min: number, step: number } | { __typename?: 'SizeFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> }>, sorts: Array<{ __typename?: 'Sort', label: string, value: SearchSortKeys }> } | null } | null };

export type CollectionDataProductCategoryFragment = { __typename?: 'ProductCategory', id: string, title: string, products?: { __typename?: 'ProductList', totalCount: number, nodes: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }>, meta: { __typename?: 'AProductConnectionMeta', defaultSortOrderPoweredBy?: MerchSource | null }, filters: Array<{ __typename?: 'ColorFilter', id: string, label: string, values: Array<{ __typename?: 'ColorFilterValue', count: number, id: string, input: any, label: string, swatch: string }> } | { __typename?: 'FabricFilter', id: string, label: string, values: Array<{ __typename?: 'FabricFilterValue', count: number, id: string, input: any, label: string, description: string }> } | { __typename?: 'GroupedListFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> } | { __typename?: 'ListFilter', id: string, label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> } | { __typename?: 'NumericSliderFilter', id: string, label: string, max: number, min: number, step: number } | { __typename?: 'SizeFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> }>, sorts: Array<{ __typename?: 'Sort', label: string, value: SearchSortKeys }> } | null };

export type CollectionDataProductCollectionFragment = { __typename?: 'ProductList', totalCount: number, nodes: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }>, meta: { __typename?: 'AProductConnectionMeta', defaultSortOrderPoweredBy?: MerchSource | null }, filters: Array<{ __typename?: 'ColorFilter', id: string, label: string, values: Array<{ __typename?: 'ColorFilterValue', count: number, id: string, input: any, label: string, swatch: string }> } | { __typename?: 'FabricFilter', id: string, label: string, values: Array<{ __typename?: 'FabricFilterValue', count: number, id: string, input: any, label: string, description: string }> } | { __typename?: 'GroupedListFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> } | { __typename?: 'ListFilter', id: string, label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> } | { __typename?: 'NumericSliderFilter', id: string, label: string, max: number, min: number, step: number } | { __typename?: 'SizeFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> }>, sorts: Array<{ __typename?: 'Sort', label: string, value: SearchSortKeys }> };

export type SearchProductsProductFragment = { __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> };

export type SearchProductsListFilterFragment = { __typename?: 'ListFilter', id: string, label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> };

export type SearchProductsSizeFilterFragment = { __typename?: 'SizeFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> };

export type SearchProductsColorFilterFragment = { __typename?: 'ColorFilter', id: string, label: string, values: Array<{ __typename?: 'ColorFilterValue', count: number, id: string, input: any, label: string, swatch: string }> };

export type SearchProductsFabricFilterFragment = { __typename?: 'FabricFilter', id: string, label: string, values: Array<{ __typename?: 'FabricFilterValue', count: number, id: string, input: any, label: string, description: string }> };

export type SearchProductsGroupedListFilterFragment = { __typename?: 'GroupedListFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> };

export type SearchProductsNumericSliderFilterFragment = { __typename?: 'NumericSliderFilter', id: string, label: string, max: number, min: number, step: number };

export type SearchProductsListFilterValueFragment = { __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string };

export type SearchProductsSortFragment = { __typename?: 'Sort', label: string, value: SearchSortKeys };

export type GetGetTheLookProductsByProductIdsQueryVariables = Exact<{
  productIds: Array<Scalars['String']> | Scalars['String'];
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type GetGetTheLookProductsByProductIdsQuery = { __typename?: 'Query', productsByProductIds: Array<{ __typename?: 'Product', gid: string, availableForSale: boolean, images: Array<string>, handle: string, title: string, tags: Array<string>, vendor: string, productType: string, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } } }> };

export type GetTheLookProductFragmentFragment = { __typename?: 'Product', gid: string, availableForSale: boolean, images: Array<string>, handle: string, title: string, tags: Array<string>, vendor: string, productType: string, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } } };

export type GetProductsByProductIdsQueryVariables = Exact<{
  productIds: Array<Scalars['String']> | Scalars['String'];
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type GetProductsByProductIdsQuery = { __typename?: 'Query', productsByProductIds: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }> };

export type SearchProductByIdProductDataFragment = { __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> };

export type GetSearchProductsQueryVariables = Exact<{
  query: Scalars['String'];
  offset?: InputMaybe<Scalars['Int']>;
  limit?: InputMaybe<Scalars['Int']>;
  filters?: InputMaybe<Array<FiltersInput> | FiltersInput>;
  sortKey?: InputMaybe<SearchSortKeys>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
}>;


export type GetSearchProductsQuery = { __typename?: 'Query', searchProducts?: { __typename?: 'AProductConnection', totalCount: number, nodes: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }>, filters: Array<{ __typename?: 'ColorFilter', id: string, label: string, values: Array<{ __typename?: 'ColorFilterValue', count: number, id: string, input: any, label: string, swatch: string }> } | { __typename?: 'FabricFilter', id: string, label: string, values: Array<{ __typename?: 'FabricFilterValue', count: number, id: string, input: any, label: string, description: string }> } | { __typename?: 'GroupedListFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> } | { __typename?: 'ListFilter', id: string, label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> } | { __typename?: 'NumericSliderFilter', id: string, label: string, max: number, min: number, step: number } | { __typename?: 'SizeFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> }>, sorts: Array<{ __typename?: 'Sort', label: string, value: SearchSortKeys }> } | { __typename?: 'Redirect', path: string } | null };

export type SearchProductsAProductConnectionFragment = { __typename?: 'AProductConnection', totalCount: number, nodes: Array<{ __typename?: 'Product', gid: string, images: Array<string>, tags: Array<string>, handle: string, title: string, availableForSale: boolean, productType: string, vendor: string, onlineStoreUrl?: any | null, totalInventory?: number | null, availableColorsMetafieldValue?: string | null, priceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, compareAtPriceRange: { __typename?: 'ProductPriceRange', maxVariantPrice: { __typename?: 'MoneyV2', amount: any }, minVariantPrice: { __typename?: 'MoneyV2', amount: any } }, options: Array<{ __typename?: 'ProductOption', name: string, values: Array<string> }> }>, filters: Array<{ __typename?: 'ColorFilter', id: string, label: string, values: Array<{ __typename?: 'ColorFilterValue', count: number, id: string, input: any, label: string, swatch: string }> } | { __typename?: 'FabricFilter', id: string, label: string, values: Array<{ __typename?: 'FabricFilterValue', count: number, id: string, input: any, label: string, description: string }> } | { __typename?: 'GroupedListFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> } | { __typename?: 'ListFilter', id: string, label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> } | { __typename?: 'NumericSliderFilter', id: string, label: string, max: number, min: number, step: number } | { __typename?: 'SizeFilter', id: string, label: string, groups: Array<{ __typename?: 'GroupListFilterGroup', label: string, values: Array<{ __typename?: 'ListFilterValue', count: number, id: string, input: any, label: string }> }> }>, sorts: Array<{ __typename?: 'Sort', label: string, value: SearchSortKeys }> };

export type AddCartLinesMutationVariables = Exact<{
  lines: Array<CartLineInput> | CartLineInput;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type AddCartLinesMutation = { __typename?: 'Mutation', cartLinesAdd?: { __typename?: 'CartLinesAddPayload', cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string, code?: CartErrorCode | null }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type CartAttributesUpdateMutationVariables = Exact<{
  attributes: Array<AttributeInput> | AttributeInput;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type CartAttributesUpdateMutation = { __typename?: 'Mutation', cartAttributesUpdate?: { __typename?: 'CartAttributeUpdate', cart: { __typename?: 'Cart', id: string, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }> }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type CartBuyerIdentityUpdateMutationVariables = Exact<{
  buyerIdentity: CartBuyerIdentityInput;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type CartBuyerIdentityUpdateMutation = { __typename?: 'Mutation', cartBuyerIdentityUpdate?: { __typename?: 'CartBuyerIdentityUpdatePayload', cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type CartCostFragment = { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } };

type CartDiscountAllocations_CartAutomaticDiscountAllocation_Fragment = { __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } };

type CartDiscountAllocations_CartCodeDiscountAllocation_Fragment = { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } };

type CartDiscountAllocations_CartCustomDiscountAllocation_Fragment = { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } };

export type CartDiscountAllocationsFragment = CartDiscountAllocations_CartAutomaticDiscountAllocation_Fragment | CartDiscountAllocations_CartCodeDiscountAllocation_Fragment | CartDiscountAllocations_CartCustomDiscountAllocation_Fragment;

export type CartFragmentFragment = { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } };

export type CartLineVariantFragment = { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null };

export type CartNoteUpdateMutationVariables = Exact<{
  note: Scalars['String'];
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type CartNoteUpdateMutation = { __typename?: 'Mutation', cartNoteUpdate?: { __typename?: 'CartNoteUpdatePayload', cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type CartWarningFragmentFragment = { __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string };

export type GetCartQueryVariables = Exact<{
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type GetCartQuery = { __typename?: 'Query', getCart?: { __typename?: 'CartPayload', customMetaField?: any | null, cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } } } | null };

export type MergeCartOnLoginMutationVariables = Exact<{
  buyerIdentity: CartBuyerIdentityInput;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type MergeCartOnLoginMutation = { __typename?: 'Mutation', mergeCartOnLogin?: { __typename?: 'CartMergePayload', cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type MigrateActiveCartMutationVariables = Exact<{
  cartId?: InputMaybe<Scalars['ID']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type MigrateActiveCartMutation = { __typename?: 'Mutation', migrateActiveCart?: { __typename?: 'CartPayload', customMetaField?: any | null, cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type UpdateCartDiscountCodesMutationVariables = Exact<{
  discountCodes?: InputMaybe<Array<Scalars['String']> | Scalars['String']>;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCartDiscountCodesMutation = { __typename?: 'Mutation', cartDiscountCodesUpdate?: { __typename?: 'CartDiscountCodesUpdatePayload', cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };

export type UpdateCartLinesMutationVariables = Exact<{
  lines: Array<CartLineUpdateInput> | CartLineUpdateInput;
  countryCode?: InputMaybe<Scalars['CountryCode']>;
  languageCode?: InputMaybe<Scalars['String']>;
}>;


export type UpdateCartLinesMutation = { __typename?: 'Mutation', cartLinesUpdate?: { __typename?: 'CartLinesUpdatePayload', cart: { __typename?: 'Cart', id: string, checkoutUrl: any, totalQuantity: number, note?: string | null, lines: { __typename?: 'BaseCartLineConnection', edges: Array<{ __typename?: 'BaseCartLineEdge', node: { __typename?: 'BaseCartLine', id: string, quantity: number, merchandise: { __typename?: 'ProductVariant', id: string, sku?: string | null, title: string, quantityAvailable?: number | null, requiresShipping: boolean, price: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, compareAtPrice?: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } | null, selectedOptions: Array<{ __typename?: 'SelectedOption', name: string, value: string }>, image?: { __typename?: 'Image', altText?: string | null, url: any } | null, product: { __typename?: 'AloProduct', handle: string, title: string, tags: Array<string>, vendor: string, description: string, id: string, isGiftCard: boolean, productType: string, collections: { __typename?: 'CollectionConnection', nodes: Array<{ __typename?: 'AloCollection', handle: string }> } }, estimatedShipDate?: { __typename?: 'MetafieldValue', value: string } | null }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, cost: { __typename?: 'CartLineCost', totalAmount: { __typename?: 'MoneyV2', amount: any }, amountPerQuantity: { __typename?: 'MoneyV2', amount: any }, compareAtAmountPerQuantity?: { __typename?: 'MoneyV2', amount: any } | null, subtotalAmount: { __typename?: 'MoneyV2', amount: any } } } }> }, attributes: Array<{ __typename?: 'Attribute', key: string, value?: string | null }>, discountAllocations: Array<{ __typename?: 'CartAutomaticDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCodeDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } } | { __typename?: 'CartCustomDiscountAllocation', discountedAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }>, discountCodes: Array<{ __typename?: 'CartDiscountCode', applicable: boolean, code: string }>, cost: { __typename?: 'CartCost', totalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode }, subtotalAmount: { __typename?: 'MoneyV2', amount: any, currencyCode: CurrencyCode } }, buyerIdentity: { __typename?: 'CartBuyerIdentity', email?: string | null, phone?: string | null, countryCode?: any | null, customer?: { __typename?: 'Customer', id: string } | null } }, userErrors: Array<{ __typename?: 'CartUserError', field?: Array<string> | null, message: string }>, warnings: Array<{ __typename?: 'CartWarning', code: CartWarningCode, target: string, message: string }> } | null };


      export interface PossibleTypesResultData {
        possibleTypes: {
          [key: string]: string[]
        }
      }
      const result: PossibleTypesResultData = {
  "possibleTypes": {
    "BrFilter": [
      "ColorFilter",
      "FabricFilter",
      "GroupedListFilter",
      "ListFilter",
      "NumericSliderFilter",
      "SizeFilter"
    ],
    "CartAddress": [
      "CartDeliveryAddress"
    ],
    "CartDiscountAllocation": [
      "CartAutomaticDiscountAllocation",
      "CartCodeDiscountAllocation",
      "CartCustomDiscountAllocation"
    ],
    "DiscountApplicationValue": [
      "MoneyV2",
      "PricingPercentageValue"
    ],
    "DisplayableError": [
      "CartUserError"
    ],
    "IFilter": [
      "ColorFilter",
      "FabricFilter",
      "GroupedListFilter",
      "ListFilter",
      "NumericSliderFilter",
      "SizeFilter"
    ],
    "IListFilterValue": [
      "ColorFilterValue",
      "FabricFilterValue",
      "ListFilterValue"
    ],
    "Merchandise": [
      "ProductVariant"
    ],
    "Node": [
      "AppliedGiftCard"
    ],
    "SearchResp": [
      "AProductConnection",
      "Redirect"
    ]
  }
};
      export default result;
    